import { motion } from "framer-motion";
import HeroBackdrop from "@/components/HeroBackdrop";

export default function PageHeader({ eyebrow, title, subtitle, align = "left" }) {
  const center = align === "center";
  return (
    <section className="relative overflow-hidden border-b border-[#1a1a22] bg-[#0b0b0f]">
      <HeroBackdrop />
      <div className={`container-kx relative py-16 sm:py-20 lg:py-24 ${center ? "text-center" : ""}`}>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className={center ? "mx-auto max-w-3xl" : "max-w-3xl"}
        >
          {eyebrow && (
            <span className={`eyebrow ${center ? "justify-center" : ""}`}>
              <span className="h-px w-6 bg-amber-400" /> {eyebrow}
            </span>
          )}
          <h1 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {subtitle && <p className="mt-5 text-lg leading-relaxed text-neutral-300">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
